// src/pages/ProfitLossReport/components/exportProfitLossXlsx.js
// Zoho-style Excel export of the Profit & Loss report (bold headings, shaded totals).
import { exportFinancialReportXlsx } from "../../../../components/common/financialReportExport";
import { toProfitLossExportRows } from "./profitLossExportRows";

/**
 * @param {object} params
 * @param {Array}   params.rows      - same rows array the table renders
 * @param {string}  params.title
 * @param {string}  params.basis     - e.g. "Accrual"
 * @param {string}  params.dateLabel - e.g. "From 01/09/2026 To 30/09/2026"
 * @param {string}  params.filename
 */
export const exportProfitLossXlsx = ({
  rows,
  title = "Profit and Loss",
  basis = "Accrual",
  dateLabel = "",
  filename = "profit_loss",
}) =>
  exportFinancialReportXlsx({
    rows: toProfitLossExportRows(rows),
    title,
    basis,
    dateLabel,
    filename,
  });
